/* eslint-disable react/require-default-props */
import React from 'react';
import { Button, FlexRow } from 'design-system';
import { getEmojiImageKey, getOptionId, isSameId } from '../surveyPreviewUtils';
import Emoji1 from '../../../../../assets/images/web_rating/emoji_1.gif';
import Emoji2 from '../../../../../assets/images/web_rating/emoji_2.gif';
import Emoji3 from '../../../../../assets/images/web_rating/emoji_3.gif';
import Emoji4 from '../../../../../assets/images/web_rating/emoji_4.gif';
import Emoji5 from '../../../../../assets/images/web_rating/emoji_5.gif';

const emojiImages = {
  1: Emoji1,
  2: Emoji2,
  3: Emoji3,
  4: Emoji4,
  5: Emoji5,
};

export default function EmojiOptions({
  options = [],
  small = false,
  preview = false,
  value,
  onChange,
  interactive = false,
}) {
  if (!options?.length) {
    return null;
  }

  return (
    <FlexRow
      align="center"
      justify={preview ? 'start' : 'center'}
      fullWidth
      className={preview ? 'cc-preview-emoji-options' : 'pt-3'}
      style={{ overflowX: 'auto' }}
      role="group"
    >
      {options.map((option, index) => {
        const optionId = getOptionId(option, index);
        const selected = isSameId(value, optionId);
        const emojiKey = getEmojiImageKey(option);

        return (
          <Button
            type="button"
            key={optionId}
            variant="link"
            className={[
              'cc-preview-emoji-option',
              small ? 'cc-preview-emoji-option--sm' : '',
              selected ? 'cc-preview-emoji-option--selected' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            aria-pressed={selected}
            disabled={!interactive}
            onClick={() => {
              if (!interactive) return;
              onChange?.(optionId);
            }}
          >
            <img
              width={small ? 50 : 125}
              height={small ? 50 : 125}
              src={emojiImages[emojiKey]}
              alt={`emoji-option-${emojiKey}`}
              className="cc-preview-emoji-option__img"
            />
          </Button>
        );
      })}
    </FlexRow>
  );
}
